export default "__VITE_ASSET__I56RTHfE__"